import React from 'react'
import { SpotlightControlsProps } from './types'
import styles from './SpotlightControls.module.scss'
import Icon, { IconType } from '@bt-react/components/Icon'

const SpotlightControls: React.FunctionComponent<SpotlightControlsProps> = ({
  focusedOnPresenterName, autoSpotlight, iconName, isObserver, onClick
}) => (
  <div className={styles['spotlight-controls']} data-bdd='spotlight-controls'>
    <div
      data-bdd='spotlight-controls-selected-presenter'
      className={styles['spotlight-controls__selected-presenter']}
    >
      <Icon name={iconName} />
      {focusedOnPresenterName ? <span>{focusedOnPresenterName} is spotlighted on screen</span> :
        (autoSpotlight && !isObserver && !focusedOnPresenterName) ? <span>Auto spotlight is on</span> :
          <span>No presenters spotlighted</span>}
    </div>
    <div
      data-bdd='spotlight-controls-select-presenter'
      className={styles['spotlight-controls__select-presenter']}
      onClick={onClick}
    >
      <Icon name={IconType.iconName.podium} />
      <span>Select presenter</span>
    </div>
  </div>
)

export default SpotlightControls